const reasons = [
  {
    number: '01',
    icon: 'ri-search-eye-line',
    title: 'Поддержка SEO-оптимизации: Защита ваших позиций',
    subtitle: 'Почему это нужно делать каждый месяц?',
    description: 'Google и Яндекс — это не статичные списки. Это живая конкуренция.',
    points: [
      {
        icon: 'ri-heart-pulse-line',
        title: 'Контроль «технического здоровья»',
        text: 'Проверяем файл robots.txt, карту сайта sitemap и скорость загрузки. Если возникнет ошибка 404 или дубль страницы — исправим до того, как поисковик снизит ваш рейтинг.',
      },
      {
        icon: 'ri-user-heart-line',
        title: 'Поведенческие факторы',
        text: 'Анализируем, как люди ведут себя на сайте. Если они стали уходить быстрее — ищем причину и исправляем её.',
      },
      {
        icon: 'ri-spy-line',
        title: 'Слежка за конкурентами',
        text: 'Если ваш конкурент вырвался вперёд, мы анализируем его методы и внедряем лучшие решения у вас.',
      },
    ],
    color: 'from-[#1A2B4C] to-[#253D6B]',
    accent: '#C5A880',
  },
  {
    number: '02',
    icon: 'ri-file-text-line',
    title: 'Контент-маркетинг: Почему SEO-статьи — это ваши «бесплатные» деньги?',
    subtitle: 'Зачем писать статьи ежемесячно?',
    description: 'Каждая новая статья — это новая «удочка», закинутая в океан поисковых запросов.',
    points: [
      {
        icon: 'ri-bar-chart-grouped-line',
        title: 'Рост охвата',
        text: 'Статьи отвечают на вопросы клиентов, которые ещё не готовы купить, но уже ищут решение (2-я и 3-я ступени «Лестницы Ханта»).',
      },
      {
        icon: 'ri-verified-badge-line',
        title: 'Доверие поисковиков',
        text: 'Яндекс и Google видят, что сайт «живой», на нём регулярно появляется полезный контент. Такие сайты они ранжируют выше.',
      },
      {
        icon: 'ri-money-dollar-circle-line',
        title: 'Экономия на рекламе',
        text: 'Статья, написанная один раз, может приводить клиентов годами — в отличие от контекстной рекламы, где трафик исчезает, как только вы перестаёте платить.',
      },
    ],
    color: 'from-[#2A3F5F] to-[#1A2B4C]',
    accent: '#C5A880',
  },
  {
    number: '03',
    icon: 'ri-tools-line',
    title: 'Технические правки: Актуальность вашего бизнеса',
    subtitle: 'В динамичном бизнесе всё меняется',
    description: 'Цены, акции, условия доставки, новые фото объектов — всё нужно держать актуальным.',
    points: [
      {
        icon: 'ri-time-line',
        title: 'Без поиска фрилансеров',
        text: 'Вам не нужно тратить время на поиск подрядчиков или разбираться в коде самостоятельно.',
      },
      {
        icon: 'ri-edit-2-line',
        title: 'До 5 корректировок в месяц',
        text: 'Уже включены в стоимость. Ваш сайт всегда содержит актуальную и точную информацию о вашем бизнесе.',
      },
      {
        icon: 'ri-refresh-line',
        title: 'Быстрое обновление',
        text: 'Любые правки вносятся оперативно — без задержек и бюрократии. Просто напишите нам, и всё будет готово.',
      },
    ],
    color: 'from-[#1A2B4C] to-[#253D6B]',
    accent: '#C5A880',
  },
];

export default function SupportWhyNeeded() {
  return (
    <section id="why-support" className="py-14 sm:py-24 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 sm:px-6">
        {/* Header */}
        <div className="text-center mb-10 sm:mb-16">
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-['Playfair_Display'] font-bold text-[#1A2B4C] mb-4 sm:mb-6 leading-tight">
            Почему сайту нужна ежемесячная поддержка?
          </h2>
          <div className="w-16 h-1 bg-[#C5A880] mx-auto mb-4 sm:mb-6 rounded-full"></div>
          <p className="text-sm sm:text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed font-['Montserrat'] text-justify">
            Представьте, что сайт — это автомобиль. Даже если он новый и быстрый, без техосмотра и заправки он рано или поздно заглохнет. Интернет-маркетинг меняется ежедневно: конкуренты выпускают новые статьи, поисковики меняют алгоритмы, а ссылки могут «биться».
          </p>
        </div>

        {/* Critical importance callout */}
        <div className="mb-10 sm:mb-16 rounded-2xl sm:rounded-3xl overflow-hidden border border-[#C5A880]/40 bg-gradient-to-br from-[#F9F5EF] to-[#FDF8F2]">
          <div className="p-6 sm:p-10 flex flex-col sm:flex-row gap-5 sm:gap-8 items-start">
            <div className="flex-shrink-0 w-12 h-12 sm:w-16 sm:h-16 rounded-xl sm:rounded-2xl bg-[#1A2B4C] flex items-center justify-center">
              <i className="ri-alert-line text-2xl sm:text-3xl text-[#C5A880]"></i>
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-lg sm:text-2xl font-bold text-[#1A2B4C] font-['Playfair_Display'] mb-3 sm:mb-4 leading-snug">
                Почему это критически важно для вашего бизнеса?
              </h3>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed font-['Montserrat'] text-justify">
                Поисковые системы (Google и Яндекс) — это живой рынок. Если ваш сайт не обновляется и не оптимизируется, он опускается в выдаче, уступая место тем, кто активно занимается своим ресурсом. Ежемесячная работа позволяет вам не «догонять» уходящий поезд, а задавать темп в своей нише.
              </p>
            </div>
          </div>
        </div>

        {/* Reasons */}
        <div className="space-y-6 sm:space-y-12">
          {reasons.map((reason, idx) => (
            <div
              key={idx}
              className={`rounded-2xl sm:rounded-3xl overflow-hidden bg-gradient-to-r ${reason.color}`}
            >
              <div className="p-5 sm:p-10">
                {/* Title row */}
                <div className="flex items-start gap-4 sm:gap-6 mb-5 sm:mb-8">
                  <div className="flex-shrink-0 w-11 h-11 sm:w-16 sm:h-16 rounded-xl sm:rounded-2xl bg-[#C5A880]/20 border border-[#C5A880]/30 flex items-center justify-center">
                    <i className={`${reason.icon} text-xl sm:text-3xl text-[#C5A880]`}></i>
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="text-[#C5A880] text-xs font-bold font-['Montserrat'] mb-1 tracking-widest uppercase">
                      Раздел {reason.number}
                    </div>
                    <h3 className="text-base sm:text-2xl font-bold text-white font-['Playfair_Display'] leading-snug">
                      {reason.title}
                    </h3>
                    <p className="text-white/70 text-xs sm:text-sm mt-1 font-['Montserrat'] text-justify">
                      <strong className="text-white/90">{reason.subtitle}</strong> — {reason.description}
                    </p>
                  </div>
                </div>

                {/* Points grid */}
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-6">
                  {reason.points.map((point, pIdx) => (
                    <div
                      key={pIdx}
                      className="bg-white/10 backdrop-blur-sm border border-white/15 rounded-xl sm:rounded-2xl p-4 sm:p-6"
                    >
                      <div className="flex items-center gap-2 mb-2 sm:block sm:mb-3">
                        <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                          <i className={`${point.icon} text-xl text-[#C5A880]`}></i>
                        </div>
                        <h4 className="text-sm font-bold text-white font-['Montserrat']">
                          {point.title}
                        </h4>
                      </div>
                      <p className="text-white/75 text-xs leading-relaxed font-['Montserrat'] text-justify sm:mt-0 mt-1">
                        {point.text}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
